export const TRITON_SDK = 'https://sdk.listenlive.co/web/2.9/td-sdk.min.js';
export const TRITON_PLAYER = 'cap_triton';
export const TRITON_PLAYER_ID = 'td_container';
